import React from 'react';
import ReactDOM from 'react-dom';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

const overlayStyle: React.CSSProperties = {
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100vw',
  height: '100vh',
  background: 'rgba(255,255,255,0.6)',
  zIndex: 2000,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center'
};

const LoadingOverlay: React.FC<{
  open: boolean;
  children?: React.ReactNode;
}> = ({ open, children }) => {
  if (!open) return null;
  return ReactDOM.createPortal(
    <Box style={overlayStyle} data-testid="loading-overlay">
      <CircularProgress size={64} />
      {children}
    </Box>,
    document.body
  );
};

export default LoadingOverlay;
